
// import { body } from "framer-motion/client";
import { apiFetch } from "./fetchApi";

export const createProfileAction = async (BeURL, showAlert, payload, setShow) => {
    try {
        //  Send companyId as query param for account creation
        const accountRes = await apiFetch(`${BeURL}/profile-action`, {
            method: "POST",
            body: JSON.stringify(payload),
        });

        const accountData = await accountRes.json()


        if (!accountData.success) {
            showAlert(accountData.message)
            return
        }


        showAlert(accountData.message);

        return true
        // setTimeout(() => {
        //     window.location.reload()

        // }, 1000);
        // if (navigate)
        //     setInterval(() => {
        //         navigate('/list-jobs')

        //     }, 1000)

        // if (setShow)
        //     setShow(false)


    } catch (err) {
        console.error("Error in create Profile Action:", err)
        alert('Trouble connecting to the server! Please try again later.')
    }

    // apiFetch(`${BeURL}/profile-action`, {
    //     method: 'POST',
    //     body: JSON.stringify(payload)
    // })
    //     .then(res => res.json())
    //     .then(data => {
    //         showAlert(data.message)
    //         window.location.reload()
    //     })
    //     .catch(err => {
    //         console.warn("Error in profile action")
    //     })
}

export const fetchProfileAction = async (BeURL, showAlert, setProfileAssign, candidateId) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/fetch-profile?candidateId=${candidateId}`, {
            method: "GET",
        })

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            // return
        }

        setProfileAssign(data.profileActions)


    } catch (err) {
        console.error("Error in Fetch All Users:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

export const fetchProfile = async (BeURL, showAlert, setProfileAssign, jobId, candidateId) => {
    try {

        // 2️⃣ Send companyId as param for get manager Ids creation
        const url = candidateId
            ? `${BeURL}/fetch-profile-action?jobId=${jobId}&candidateId=${candidateId}`
            : `${BeURL}/fetch-profile-action?jobId=${jobId}`;
        const res = await apiFetch(url, {
            method: "GET",
        })

        const data = await res.json();
        if (!data.success) {
            // showAlert(data.message);
            return;
        }

        setProfileAssign(data.profileActions)


    } catch (err) {
        console.error("Error in Fetch All Users:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

export const fetchPaginationProfile = async (BeURL, showAlert, jobId, currentPage, searchTerm, itemsPerPage, type,
    setAllProfiles, setTotalPages, settotalProfiles) => {
    try {

        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/fetch-profile-actions?jobId=${jobId}`, {
            method: "POST",
            body: JSON.stringify({ page: currentPage, searchTerm, profilePerPage: itemsPerPage, type })
        })

        const data = await res.json();
        if (!data.success) {
            // showAlert(data.message);
            return;
        }

        setAllProfiles(data.profiles)
        setTotalPages(data.totalPages)
        settotalProfiles(data.totalProfiles)


    } catch (err) {
        console.error("Error in Fetch All Users:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

export const deleteProfileAction = async (BeURL, showAlert, setLoading, jobId, candidateId) => {
    try {
        if (!candidateId || !jobId) {
            showAlert("Candidate and Job Ids are not found! Kindly contact support team.")
        }
        setLoading(true)

        const res = await apiFetch(`${BeURL}/delete-profile-action`, {
            method: "POST",
            body: JSON.stringify({ jobId, candidateId })
        })

        const data = await res.json();
        showAlert(data.message || "");
        setLoading(false)

        if (data.success) {
            setTimeout(() => {
                window.location.reload()
            }, [800])
        }
    }
    catch (err) {
        setLoading(false)
        console.error("Error in Deleting Profile action:", err);
        showAlert('Trouble connecting to the server! Please try again later.');
    }
}